// extracted by mini-css-extract-plugin
module.exports = {"componentSpan":"theme_componentSpan__1b5Ch","swingTopHeader":"theme_swingTopHeader__3_0eR","legend":"theme_legend__2STCJ","legendBox":"theme_legendBox__3Tu2n"};